const STRINGS = {
  disabledNextButtonAriaLabel: "Next page",
  disabledPreviousButtonAriaLabel: "Previous page",
  items: "Items",
  itemsInTrigger: "items",
  itemsPerPage: "items per page",
  itemsPerPageDetails: "Shows controls for navigating to a specific page of items.",
  itemsPerPageListAriaLabel: "items per page controls",
  itemsPerPageTitle: "Items per page",
  menuTriggerDetails: "Use this control to select a different page of items, or change the number of items displayed per page.",
  next: "Next",
  of: "of",
  previous: "Previous",
  selected: "selected",
  through: "through",
  to: "to",
  viewing: "Showing",
  viewItemsDetails: "Shows controls for navigating to a specific page of items.",
  viewItemsListAriaLabel: "page controls",
  viewItemsNextButtonAnnouncement: "Showing next pages of items to choose from.",
  viewItemsNextButtonDetails: "Navigates to next pages of items to choose from for display.",
  viewItemsPreviousButtonAnnouncement: "Showing previous pages of items to choose from.",
  viewItemsPreviousButtonDetails: "Navigates to previous pages of items to choose from for display.",
  viewItemsTitle: "View items",
  currentItemsTextInTrigger: (startOfRange, endOfRange) => `${startOfRange} to ${endOfRange}`,
  viewListItemsText: (startOfRange, endOfRange) => `${startOfRange} to ${endOfRange}`
};
export default STRINGS;